import { render } from "./StepComms.vue?vue&type=template&id=5a924b92&scoped=true"
import script from "./StepComms.vue?vue&type=script&lang=js"
export * from "./StepComms.vue?vue&type=script&lang=js"

import "./StepComms.vue?vue&type=style&index=0&id=5a924b92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a924b92"]])

export default __exports__